module.exports = __webpack_public_path__ + "img/nepomucen.234507b0.jpg";